<template>
	<v-card outlined class="p-relative d-flex flex-column align-stretch" :class="statusCard">

		<!-- Chips -->
		<v-layout class="p-absolute d-flex flex-row full-width ma-0 pa-0 z-4" style="top: 0; right: 0; z-index: 3;">
			<span v-if="loteDestino.blPreAlojado" class="text-selecionado mt-1 mx-4">Pré-alojado
			</span>
			<div class="status-chip-group d-flex ma-0 pa-0">
				<v-chip class="status-chip-error" v-if="loteDestino.blUltrapassaLimiteVazio" small>
					<span class="status-text">Vazio excedido</span>
				</v-chip>
				<v-chip class="status-chip-alojamento-parcial" v-if="somaQtTotalAlocados > 0 &&
				somaQtTotalAlocados < loteDestino.qtCapacidadeUep
				&& podeAlocar" small>
					<span class="status-text">Alojamento parcial</span>
				</v-chip>
				<v-chip class="status-chip-sem-alojamento" v-else-if="podeAlocar" small>
					<span class="status-text">Sem alojamento</span>
				</v-chip>
			</div>
		</v-layout>

		<v-container>
			<!-- Title -->
			<v-row fluid class="px-4 my-3 d-flex flex-column">
				<span class="data-label">Produtor</span>
				<span class="data-value-small">{{ loteDestino.nmProdutor }}</span>
			</v-row>

			<!-- Info -->
			<v-row fluid class="px-1 d-flex card--date">
				<v-col class="d-flex flex-column text-no-wrap px-3" cols="3">
					<span class="data-label">UEP</span>
					<span class="data-value-small">{{ loteDestino.nrUnidadeExploracao }}</span>
				</v-col>
				<v-col class="d-flex flex-column text-no-wrap px-1" cols="6">
					<span class="data-label">Cidade</span>
					<span class="data-value-small">{{ crechario.dadosCreche.nmMunicipio }}</span>
				</v-col>
				<v-col class="d-flex flex-column text-no-wrap px-1" cols="2">
					<span class="data-label">Distância</span>
					<span class="data-value-small">{{ loteDestino.nrDistanciaCreche }} Km</span>
				</v-col>
			</v-row>

			<!-- Status Lote -->
			<v-row fluid class="pa-0">
				<v-col class="d-flex flex-column" cols="6">
					<span class="data-label flex-nowrap">Dias em vazio</span>
					<span :class="loteDestino.blUltrapassaLimiteVazio ? ' data-value-primary' : ' data-value-secondary'">
						{{ loteDestino.qtVazioSanitario }} dias
					</span>
				</v-col>
				<v-col class="d-flex flex-column text-no-wrap" cols="6">
					<span class="data-label">Alocados</span>
					<span class="data-value">{{ somaQtTotalAlocados }} em {{ loteDestino.qtCapacidadeUep || '--' }}</span>
				</v-col>
			</v-row>

			<!-- Observação -->
      <v-row fluid class="d-flex flex-column px-3 pt-3 pb-2 card--date">
        <span class="data-label">Observação</span>
        <div class="observacao-lote-destino">
	        {{ loteDestino.dsObservacao ? loteDestino.dsObservacao : '--' }}
        </div>
      </v-row>

			<!-- Checkboxes -->
			<v-row class="ma-0 pa-0 pt-2 flex-nowrap data-value-small">
				Data de alojamento
				<span class="label-info">
	        <v-tooltip top max-width="160px">
            <template v-slot:activator="{ on, attrs }">
              <v-icon size="9px" color="grey" class="mb-2" v-bind="attrs"
                      v-on="on">fas fa-question-circle</v-icon>
            </template>
            <span class="tooltip">Valor referente ao período do planejamento; Este valor é uma
                                  previsão.</span>
          </v-tooltip>
          </span>
			</v-row>
			<v-row class="ma-0 pa-0 overflow-auto flex-nowrap">
				<div
						v-for="(itemData, idx) in listaDatas"
						:key="itemData.data"
						class="pa-1" style="min-height: 61px"
				>
					<alocar-lotes-checkbox
							v-if="diaDisponivel(idx + 1)"
							v-model="selectedDays"
							:pode-alocar="podeAlocar"
							:dt-inicio-vazio="loteDestino['dtInicioVazio']"
							:true-value="{
								stDiaAlocado: `qtDia${idx + 1}`,
								dtAlocado: itemData.data,
								id: loteDestino['id'],
							}"
					/>
				</div>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import moment from "moment"
import {MODELS, UTILS} from "../../resources";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex"
import AlocarLotesCheckbox from "./AlocarLotesCheckbox";
import axios from "axios";

export default {
	name: "AlocarLotesCard",
	components: {AlocarLotesCheckbox},
	data: () => ({
		// lotesAlocados: [],
		loading: false,
	}),
	filters: {
		genderDisplay(value) {
			switch (value) {
				case "MA":
					return "Macho"
				case "FE":
					return "Fêmea"
				case "MI":
					return "Misto"
				default:
					return ""
			}
		},
	},
	computed: {
		...mapState("planejamentoAlojamento", ["listaLotesAlocados"]),
		...mapGetters("planejamentoAlojamento", ["getLotesSelecionadosByCreche"]),
		selectedDays: {
			get() { return this.lotesSelecionados },
			set(selecao) { this.$emit('update:lotesSelecionados', selecao) }
		},
		podeAlocar() {
			if (this.somaQtTotalAlocados === 0) return true
			return this.somaQtTotalAlocados < this.loteDestino['qtCapacidadeUep']
		},
		statusCard() {
			return this.loteDestino['blPreAlojado'] ? ' border-selecionado' : ' border-error'
		},
		somaQtTotalAlocados() {
			if (this.listaLotesAlocados.length === 0 || !this.loteDestino) return 0

			const lotesAlocadosMesmoLoteDestino = this.listaLotesAlocados.filter(lote =>
					lote.cdPlanejamentoAlojamentoLoteDestino ===
					this.loteDestino.idPlanejamentoAlojamentoLoteDestino)

			return lotesAlocadosMesmoLoteDestino.length > 0 ?
					lotesAlocadosMesmoLoteDestino.reduce((acc, lote) => acc + parseInt(lote.qtMachosAlocados || 0) +
							parseInt(lote.qtFemeasAlocados || 0), 0) :
					0
		},
	},
	methods: {
		...mapActions("planejamentoAlojamento", ["ActLoadListaLoteAlocado"]),
		...mapMutations("planejamentoAlojamento", ["mtChangeLoteDestino", "mtChangeListaLoteAlocado"]),
		diaDisponivel(dia) {
			const disponibilidadeDoDia = this.crechario['qtFemeasDia' + dia] + this.crechario['qtMachosDia' + dia]
			return disponibilidadeDoDia > 0
		},
	},
	mounted() {
		//regra para o sort
		// if (this.loteDestino.idPlanejamentoAlojamentoLoteDestino > 0) {
			// const lotesAlocados = this.listaLotesAlocadosByLoteDestino(
			// 		this.loteDestino.idPlanejamentoAlojamentoLoteDestino,
			// 		this.crechario.cdCrecheSemLote,
			// 		this.crechario.cdLoteProducaoCreche)
			//
			// if (lotesAlocados) this.selectedDays = lotesAlocados.map(lote => ({
			// 	dtAlocado: lote.dtAlocado,
			// 	stDiaAlocado: lote.stDiaAlocado,
			// 	id: this.loteDestino.id
			// }))
		// }
	},
	props: {
		loteDestino: {
			type: Object,
			required: true
		},
		crechario: {
			type: Object,
			required: true
		},
		listaDatas: {
			type: Array,
			required: true
		},
		lotesSelecionados: {
			type: Array,
			required: true,
		}
	},
}
</script>

<style scoped lang="scss">
.data-label {
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0;
  color: #12303C99;
}

.data-value-small {
  font: normal normal bold 12px/16px Roboto;
  letter-spacing: 0;
  color: #37565C;
}

.data-value-primary {
  font: normal normal bold 16px/21px Roboto;
  letter-spacing: 0;
  color: #FF5252;
}

.data-value-secondary {
  font: normal normal bold 16px/21px Roboto;
  letter-spacing: 0;
}

.data-value {
  font: normal normal bold 16px/21px Roboto;
  letter-spacing: 0;
  color: #10303DCC;
}

.data-sub-label {
  font: normal normal medium 12px/16px Roboto;
  letter-spacing: 0;
  color: #37565C;
}

.card--date {
  background: #f7f7f7 0 0 no-repeat padding-box;
  opacity: 1;
}

.status-chip-group {
  position: absolute;
  right: 4px;
  top: 3px;
}

.status-chip-error {
  background-color: #FFEDED !important;
  height: 14px;

  .status-text {
    font: normal normal bold 09px/10px Roboto;
    text-transform: capitalize;
    letter-spacing: 0;
    color: #FF5252;
    opacity: 0.9;
  }
}

.status-chip-alojamento-parcial {
  background-color: #F5B80033 !important;
  height: 14px;

  .status-text {
    font: normal normal bold 09px/10px Roboto;
    text-transform: capitalize;
    letter-spacing: 0;
    color: #DE8900;
    opacity: 0.9;
  }
}

.status-chip-sem-alojamento {
  background-color: #7B959633 !important;
  height: 14px;

  .status-text {
    font: normal normal bold 09px/10px Roboto;
    text-transform: capitalize;
    letter-spacing: 0;
    color: #7B9596;
    opacity: 0.9;
  }
}

.border-error {
  //border: 2px solid #FF5252;
  box-shadow: 0 0 0 1.2px #FF5252;
}

.border-selecionado {
  //border: 1px solid #008EF0;
  box-shadow: 0 0 0 1.3px #008EF0;
}

.text-selecionado {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: #008EF0;
}

.observacao-lote-destino {
  font: normal normal bold 12px/16px Roboto;
  letter-spacing: 0;
  color: #4b5e62;
	height: 44px;
	overflow-x: hidden;
	overflow-wrap: anywhere;
}

</style>
